export default __webpack_public_path__ + "static/media/phone.dcc51d21.svg";